import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Button, Header, Segment } from 'semantic-ui-react'

import Layout from '~/components/Layout'
import { RouteTypes } from '~/routes/constants'

type SetPasswordProps = {
  resetPassword?: boolean
}
const SetPassword: React.FC<SetPasswordProps> = (props) => {
  const { resetPassword } = props
  const { t } = useTranslation()
  const location = useLocation()
  const navigate = useNavigate()

  function getTitle() {
    return resetPassword ? t('Reset password error') : t('Set password error')
  }

  function getSubheader() {
    return resetPassword ? t('Please log out in order to reset password.') : t('Please log out in order to set password.')
  }

  function handleLogOutAndSetPassword() {
    const arrayOfUrlValues = location.pathname.split('/')
    const id = arrayOfUrlValues[1] || ''
    const code = arrayOfUrlValues[2] || ''
    localStorage.removeItem('token')
    const path = resetPassword ? RouteTypes.RESET_PASSWORD_LOGGED.replace(':id', id).replace(':code', code) : RouteTypes.SET_PASSWORD_LOGGED.replace(':id', id).replace(':code', code)
    navigate(path)
  }

  return <Layout title={t('Error')}>
    <Segment padded style={{ margin: '4em', textAlign: 'center' }}>
      <Header as='h1' content={getTitle()} subheader={getSubheader()} />
      <Button primary
        onClick={() => handleLogOutAndSetPassword()}
      >
        {resetPassword ? t('Log out and reset password') : t('Log out and set password')}
      </Button>
    </Segment>
  </Layout>
}
export default SetPassword
